import { tuple } from '@bydesign-ui/utils';
export var SUPPORT_TYPES_LIST = tuple('hue', 'saturation', 'light', 'alpha');